// src/App.jsx
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LangProvider } from './lib/i18n.jsx';
import Home from './pages/Home.jsx';
import Chat from './pages/Chat.jsx';
import Resources from './pages/Resources.jsx';

export default function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="/resources" element={<Resources />} />
        </Routes>
      </BrowserRouter>
    </LangProvider>
  );
}
